import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SearchButton from './components/searchButton';
import ClearButton from './components/clearButton';

const SearchFormButtonContainer = styled.div`
    position: fixed;
    margin-left: 55%;
    top: 25%;

    button {
        margin-right: 20px;
        margin-bottom: 20px;
    }

    @media screen and (max-width: 740px) {
        margin-left: 70%;
    }
`;

const SearchFormButtons = ({
    searchHandler,
    clearHandler,
}) => (
    <SearchFormButtonContainer>
        <SearchButton clickHandler={searchHandler} />
        <ClearButton clickHandler={clearHandler} />    
    </SearchFormButtonContainer>    
)

SearchFormButtons.propTypes = {
    searchHandler: PropTypes.func,
    clearHandler: PropTypes.func,
};

export default SearchFormButtons;


// WEBPACK FOOTER //
// ./src/components/searchForm/components/searchFormButtons/searchFormButtons.js